<template>
  <div class="Field-Pass">
      <FieldHeader
        class="Field-Pass__hdr"
        :label="label"
        :option="option"
        :maxItems="maxSybmols"
        :counter="counter"
        v-if="isHeaderShowed"
      />
    <div class="Field-Pass__input-box">
      <input
        class="Field-Pass__input"
        ref="input"
        v-model="currentValue"
        @input="onInputChange"
        :class="get_errorClass"
        :name="name"
        :placeholder="placeholder"
        :type="get_visibleType"
      />
      <EyeOpened class="Field-Pass__eye" v-if="isPasswordHidden" @click="toChangeHideMode"/>
      <EyeClosed class="Field-Pass__eye" v-else @click="toChangeHideMode"/>
    </div>
    <p class="Field-Pass__error-txt" v-if="get_isError">{{ props.errorMessage }}</p>
  </div>
</template>

<script setup>
import {ref, computed, defineProps} from 'vue';
import {Props} from "./scripts/props";
//-------------------------------------
import EyeOpened from '@svg/EyeOpened.vue';
import EyeClosed from '@svg/EyeClosed.vue';
import FieldHeader from "@ui/Fields/FieldHeader/FieldHeader.vue";
//-------------------------------------
const props = defineProps(Props());
const emit = defineEmits(['update:modelValue']);
//-------------------------------------
const isPasswordHidden = ref(true);
const currentValue = ref(props.modelValue);
//-------------------------------------
//Добавить класс ошибки, если таковая присутствует
const get_errorClass = computed(() => get_isError.value || props.isError ? 'Field-Pass__input--error' : '');
//Определить видимость поля
const get_visibleType = computed(() => isPasswordHidden.value ? 'password' : 'text');
//Отображать ли текст ошибки
const get_isError = computed(() => props.errorMessage && props.errorMessage !== '');
//Отображат ли шапку для поля
const isHeaderShowed = computed(() => props.label || props.option || props.maxSybmols);
//-------------------------------------
//Переключить видимость поля
const toChangeHideMode = () => {
  isPasswordHidden.value = !isPasswordHidden.value;
};
//Изменение поля
const onInputChange = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>

<style lang="scss">
@import './styles/_conf';
</style>
